// extracted by mini-css-extract-plugin
export default {"metric":"MeetingAnalytics_metric__2QvE4"};